import {React, Component} from "react";


class something_wrong extends Component{
    dahboardclick =()=>{
        this.props.history.push({pathname : "/dashboard"})
    }
    render(){
        return(
            <div  className="col-12 mt-sm-5" style={{textAlign:"center", }}>
                  <img    className="img-fluid" alt="Responsive image" src={process.env.REACT_APP_ENV +"/assets/images/404/Something_wrong_New.png"} alt="View" />
                  <div style={{textAlign:"center", marginTop:"15px"}}>
                  <h1> !Oops Something Went Wrong</h1>
                  </div>
                  <div><button className="btn btn-lg btn-primary" onClick={this.dahboardclick}>Go to Dashboard</button></div>
          </div>
        )
    }
}


export default something_wrong